import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { ApiErrorAdapter } from './api-error-adapter.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private notificationService: NotificationService,
    private apiErrors: ApiErrorAdapter,
  ) {}

  public handleError(error: HttpErrorResponse): Observable<never> {
    const errorMessage = this.apiErrors.from(error).message;
    this.notificationService.showToastError(error);

    return throwError(() => errorMessage);
  }
}
